import { API_URL } from '../../../app-config/constants';
import CalendarEventDto from '../../../types/CalendarEventDto';
import { CalendarConfiguration } from '../../../types/MeetingCalendarConfiguration';
import { CalendarProvider } from '../../../types/MeetingCalendarEventDto';
import { get, put } from '../request';

export function getProvider() {
    return get<CalendarProvider | undefined>(`${API_URL}/meeting-calendar-integration/provider`);
}

export function getConfiguration(companyId?: string) {
    return get<CalendarConfiguration>(
        `${API_URL}/meeting-calendar-integration/configuration${companyId ? '/' + companyId : ''}`
    );
}

export function updateConfiguration(configuration: CalendarConfiguration) {
    return put<void>(`${API_URL}/meeting-calendar-integration/configuration`, {
        postData: configuration,
    });
}

export function getEvents(companyId: string, userId: string) {
    return get<CalendarEventDto[]>(
        `${API_URL}/meeting-calendar-integration/companies/${companyId}/users/${userId}/events`
    );
}
